export const parseJSON = json => {
  try {
    return JSON.parse(JSON.stringify(json))
  } catch (err) {
    return json
  }
}
